export default __webpack_public_path__ + "static/media/35.ac25f952.mp3";